import Quote from './containers/quoteContainer';

export default Quote;
